import { useEffect, useState } from "react";

const Select = ({ className, name, val, options, onChange }) => {

  const [inputValue, setInputValue] = useState(""); // Estado para controlar o valor do input

  useEffect(() => {
    // Definir o valor do input após o componente carregar
    setInputValue(val);
  }, [val]);

  const handleChange = (e) => {
    setInputValue((val ? val : e.target.value)); // Atualiza o estado local com o valor do input
    onChange && onChange(e.target.value); // Chama a função onChange passada via props, se houver
  };

  return (
    <>
    <label className="font-roboto block mb-2 text-sm font-bold text-gray-900 dark:text-white">Escolha uma opção:
      <select
        className={`border p-2 rounded ${className}`} // classes básicas de estilo + classes recebidas via props
        name={name}
        value={inputValue}
        onChange={handleChange}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
    </>
  );
};

export default Select;